import { Injectable } from '@angular/core';
import { CommonHttpService } from '@app/core/services/common-http.service';
import { NotificationTokenModel } from '../models/response-model';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ReadNotification } from '@app/modules/shipper/models/resmodel/product.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
 
  route = 'user/fs-token-registration'
  notificationRoute = 'user/notification'
  deleteNotification = 'user/delete-notification'
  private readonly _notifications = new BehaviorSubject<any[]>([]);
  public readonly notifications$ = this._notifications.asObservable();
  private readonly _notificationUpdated = new Subject<void>();
  public readonly notificationUpdated$ = this._notificationUpdated.asObservable();

  constructor(
    private commonHttpService: CommonHttpService,
  ) { }

  public sendToken(argToken:NotificationTokenModel): Observable<any>{
    return this.commonHttpService.post(`${this.route}`, argToken);
  }
  
  public getNotification(): Observable<any> {
    return this.commonHttpService.get<any>(`${this.notificationRoute}`).pipe(
      tap(res => {
        if (res?.data) {
          this._notifications.next(res.data);
        }
      })
    );
  }

  public pushRealtimeNotification(notification: any): void {
    if (!notification) {
      return;
    }
    const currentNotifications = this._notifications.value || [];
    this._notifications.next([notification, ...currentNotifications]);
    this._notificationUpdated.next();
  }

  public refreshNotifications(): void {
    this._notificationUpdated.next();
  }

  public readNotification(argId:number,read:ReadNotification): Observable<any>{
    return this.commonHttpService.put<ReadNotification,ReadNotification>(`${this.notificationRoute}/${argId}`,read)

  }

  public clearNotification(): Observable<any>{
    return this.commonHttpService.delete(`${this.deleteNotification}`);
  }
  
}
